import { render, staticRenderFns } from "./SelectDashboard.vue?vue&type=template&id=df64826c&scoped=true"
import script from "./SelectDashboard.vue?vue&type=script&lang=js"
export * from "./SelectDashboard.vue?vue&type=script&lang=js"
import style0 from "./SelectDashboard.vue?vue&type=style&index=0&id=df64826c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df64826c",
  null
  
)

export default component.exports